import { View, StyleSheet } from "react-native";
import { useMemo, useRef } from "react";

import { useGetProjectSubmissionsByStudentQuery } from "../graphql/generated/graphql";
import Loader from "../components/common/status/Loader/Loader";
import CustomSpacing from "../components/common/layout/CustomSpacing/CustomSpacing";
import CustomText from "../components/common/general/CustomText/CustomText";
import { useNavigation } from "@react-navigation/native";
import { NativeStackNavigationProp } from "@react-navigation/native-stack";
import type { RootStackParamList } from "../navigation/navigation.types";

import ProjectCardList from "../components/project/ProjectCardList/ProjectCardList";
import { useAuth } from "../hooks/useAuth";

function ProjectsView() {
  const scrollViewRef = useRef(null);
  const navigation = useNavigation<NativeStackNavigationProp<RootStackParamList>>();

  const { userInfo } = useAuth();

  const { data: projectsData, loading: projectsLoading } = useGetProjectSubmissionsByStudentQuery({
    variables: {
      studentId: userInfo.userId,
    },
    skip: !userInfo.userId,
  });

  const handleProjectPress = (projectId) => {
    navigation.navigate("Project", {
      id: projectId,
    });
  };

  const activeProjects = useMemo(() => {
    return projectsData?.getProjectSubmissionsByStudent?.data?.filter((project) => {
      return project.totalTasks > 0;
    });
  }, [projectsData]);

  return (
    <>
      <View ref={scrollViewRef} style={styles.scrollView}>
        {projectsLoading && (
          <View style={styles.loaderContainer}>
            <CustomText text="Loading your active projects..." style={null} />
            <CustomSpacing type="vertical" />
            <Loader />
          </View>
        )}
        <ProjectCardList
          projects={activeProjects}
          onJourneyPress={handleProjectPress}
          journeysLoading={projectsLoading}
        />
      </View>
    </>
  );
}

const styles = StyleSheet.create({
  scrollView: {
    height: 20,
    paddingHorizontal: 10,
  },
  loaderContainer: {
    justifyContent: "center",
    alignItems: "center",
  },
});

export default ProjectsView;
